// Currency utilities for mapping ISO 4217 codes to display symbols and formatting amounts

const SYMBOLS: Record<string, string> = {
  AUD: '$',
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: '$',
  NZD: '$',
  AED: 'د.إ',
  JPY: '¥',
  INR: '₹'
};

export const currencySymbol = (code?: string): string => {
  if (!code) return '$';
  return SYMBOLS[code.toUpperCase()] || code.toUpperCase();
};

export const formatCurrency = (amount: number | string, code: string, opts: { minimumFractionDigits?: number } = {}) => {
  const num = typeof amount === 'number' ? amount : parseFloat(String(amount));
  if (!isFinite(num)) return `${currencySymbol(code)}0.00`;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code.toUpperCase(),
      minimumFractionDigits: opts.minimumFractionDigits ?? 2
    }).format(num);
  } catch {
    return `${currencySymbol(code)}${num.toFixed(opts.minimumFractionDigits ?? 2)}`;
  }
};
